// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  align-items: flex-end;
  display: flex;
  gap: 4px;
  justify-content: var(--header-spacing);
  margin-bottom: 2px;
}

.label-container {
  display: block;
  padding: var(--label-padding) 0;
}

::slotted(label[slot=label]) {
  /*
   * margin and padding moved to .header and
   * .label-container respectively when slotted.
   */
  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */
  padding: 0 !important;
}

.label-aside {
  display: flex;
  gap: 2px;
}

:host(.is-invalid) .control-container:not(.has-control) {
  background-color: var(--color-error-10);
  display: inline-block;
  margin: -2px;
  padding: 2px;
}

/* Validation hint and error message */

.invalid-feedback,
.validation-hint {
  line-height: var(--label-line-height);
  margin: 4px 0 0;
}

.validation-hint {
  color: var(--gray-06);
}

/*
 * Validation hint and error message are not shown if the form group is disabled.
 * And they're not shown at the same time.
 */

.invalid-feedback:empty,
.validation-hint:empty,
:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,
:host(:is(.is-disabled, .is-invalid)) .validation-hint {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/form-group/form-group.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,aAAa;EACb,QAAQ;EACR,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE;;;IAGE;EACF,oBAAoB,EAAE,sEAAsE;EAC5F,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;EACrB,YAAY;EACZ,YAAY;AACd;;AAEA,sCAAsC;;AAEtC;;EAEE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE;;AACF;;;;EAIE,aAAa;AACf","sourcesContent":[".header {\n  align-items: flex-end;\n  display: flex;\n  gap: 4px;\n  justify-content: var(--header-spacing);\n  margin-bottom: 2px;\n}\n\n.label-container {\n  display: block;\n  padding: var(--label-padding) 0;\n}\n\n::slotted(label[slot=label]) {\n  /*\n   * margin and padding moved to .header and\n   * .label-container respectively when slotted.\n   */\n  margin: 0 !important; /** !important because otherwise an unwanted line break might occur. */\n  padding: 0 !important;\n}\n\n.label-aside {\n  display: flex;\n  gap: 2px;\n}\n\n:host(.is-invalid) .control-container:not(.has-control) {\n  background-color: var(--color-error-10);\n  display: inline-block;\n  margin: -2px;\n  padding: 2px;\n}\n\n/* Validation hint and error message */\n\n.invalid-feedback,\n.validation-hint {\n  line-height: var(--label-line-height);\n  margin: 4px 0 0;\n}\n\n.validation-hint {\n  color: var(--gray-06);\n}\n\n/*\n * Validation hint and error message are not shown if the form group is disabled.\n * And they're not shown at the same time.\n */\n.invalid-feedback:empty,\n.validation-hint:empty,\n:host(:is(.is-disabled, :not(.is-invalid))) .invalid-feedback,\n:host(:is(.is-disabled, .is-invalid)) .validation-hint {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
